import React from "react";

export const Icon = props => {	
	const { src, className, clickAction } = props;
	
	return (
		<img
			className={`tv-icon ${className || ""}`}
			src={src || ""}
			onClick={clickAction ? clickAction : () => null}
		/>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/Icon.js